export const constants = {
  trxRetry: 60, // 1 minute
};
